<script setup lang="ts">
import { ref, watch } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { useRoute } from 'vue-router';

const route = useRoute();

const searchText = ref(route.query.caseFilter as string | null);
const emits = defineEmits(['onSearch']);

watch(() => route.query.caseFilter, () => {
  searchText.value = route.query.caseFilter as string | null;
});

const onSearch = () => {
  emits('onSearch', searchText.value);
};

const onInput = () => {
  if (searchText.value === '') {
    emits('onSearch', searchText.value);
  }
};
</script>

<template>
  <div class="case-search-root">
    <InputText id="search"
      v-model="searchText"
      type="text"
      @input="onInput"
      placeholder="Filter cases (case-sensitive)"
      class="case-search-input"/>
    <Button icon="pi pi-search"
      outlined
      class="search-button"
      @click="onSearch"
      v-ripple/>
  </div>
</template>

<style scoped lang="scss">
@import "../../../assets/main.scss";
.case-search-root {
  display: flex;
}
.case-search-input {
  font-size: 14px;
  min-width: 250px;
}
.search-button {
  margin-left: 12px;

  border: 1px solid $disabled;
}
</style>
